import api from "./axios";
import { chatFileUrl } from "../utils/chatFiles";

/**
 * The signed-in person's chat with Mintly support. Admins answer it from the admin panel.
 * @see mintly-back/src/controllers/supportController
 */

/** My conversation (null before my first message) and its latest messages; reads them. */
export const getMySupportChat = async (before = null) => {
  const response = await api.get("/support", { params: before ? { before } : {} });
  return response.data;
};

export const sendSupportMessage = async (content) => {
  const response = await api.post("/support/messages", { content });
  return response.data;
};

/** Send support a photo, video or file, with an optional caption. */
export const sendSupportAttachment = async (file, content = "", onProgress) => {
  const form = new FormData();
  if (content) form.append("content", content);
  form.append("fileName", file.name);
  form.append("file", file);
  const response = await api.post("/support/attachments", form, {
    onUploadProgress: (e) => onProgress?.(e.total ? e.loaded / e.total : 0),
  });
  return response.data;
};

/** Where a photo, video or file in my support chat is shown from — or saved, with `{ download: true }`. */
export const supportFileUrl = (messageId, options) => chatFileUrl(`/support/messages/${messageId}/file`, options);

/** Support's replies that arrived while the chat was open have been read. */
export const markSupportRead = async () => {
  const response = await api.post("/support/read");
  return response.data;
};
